shadow$provide[2103] = function(require,module,exports) {
module.exports=(jspdf);
};